import React from 'react';

const projects = [
  {
    id: 1,
    title: 'Haggiga Organics Website',
    desc: 'A professional website for Haggiga Organics, showcasing their organic products and brand identity.',
    type: 'web',
    link: 'https://haggigaorganics.com/',
    logo: '/haggiga-logo.jpg',
    tag: 'Web Development',
    techs: ['HTML', 'CSS', 'JavaScript', 'React'],
  },
  {
    id: 2,
    title: 'Nile Orphan Care Company Profile',
    desc: 'A professionally designed company profile document for Nile Orphan Care, created for print and digital distribution.',
    type: 'pdf',
    link: '/profile.pdf',
    logo: '/noc_logo.png',
    tag: 'Graphic Design',
    techs: ['Adobe Illustrator', 'Canva', 'Print Design'],
  },
  {
    id: 3,
    title: 'Personal Portfolio Website',
    desc: 'A modern, responsive portfolio website built with React, featuring a navy, white, and red color scheme.',
    type: 'web',
    link: 'https://www.ajangakoi.com/',
    logo: '/avatar.jpg',
    tag: 'Web Development',
    techs: ['React', 'CSS', 'JavaScript', 'React Router'],
  },
];

function Projects() {
  return (
    <div className="page-wrapper">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">My Projects</h1>
          <p className="page-hero-subtitle">A showcase of my work and achievements</p>
        </div>
      </section>

      <section className="page-section">
        <div className="page-container">
          <h2 className="page-section-title">Featured Work</h2>
          <div className="projects-pro-grid">
            {projects.map(p => (
              <div key={p.id} className="project-pro-card">
                <div className="project-pro-logo-wrap">
                  <img src={p.logo} alt={p.title} className="project-pro-logo" />
                </div>
                <div className="project-pro-body">
                  <span className="project-pro-tag">{p.tag}</span>
                  <h3 className="project-pro-title">{p.title}</h3>
                  <p className="project-pro-desc">{p.desc}</p>
                  <div className="project-pro-techs">
                    {p.techs.map((t, i) => <span key={i} className="tech-chip">{t}</span>)}
                  </div>
                  <a href={p.link} target="_blank" rel="noopener noreferrer" className="project-pro-btn">
                    {p.type === 'pdf' ? 'View Document' : 'Visit Website'}
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24" style={{marginLeft:'6px'}}><path d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;
